import React, { useState } from "react";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { checkObjHasAllValue } from "../../../../components/ui_comps/ComissionContainer";
import { useSnackbar } from "notistack";
import { validateEmail } from "../../../../../utility/emailValidator";
import CheckBoxInput from "../../../../components/ui_comps/CheckBoxInput";
function BasicDetailsUser({ onClickBack, onClickNext }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [internal, setInternal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: 500,
        minWidth: 300,
        minHeight: 400,
      }}
    >
      {" "}
      <CustomInput
        value={firstName}
        onChange={(data) => setFirstName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="First Name"
        validator="name"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
      <CustomInput
        value={lastName}
        onChange={(data) => setLastName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Last Name"
        validator="name"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
      <CustomInput
        value={email}
        onChange={(data) => setEmail(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Email id"
        validator="email"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
      <CustomInput
        value={mobileNumber}
        onChange={(data) => setMobileNumber(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Mobile number"
        validator="mobile"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
      <CheckBoxInput
        title="Internal User"
        value={"Internal"}
        onChange={(e) => {
          setInternal(e.target.checked);
        }}
        mainStyle={{
          ...containerStyle,
        }}
      />
      <div
        style={{
          display: "flex",
          gap: 20,
          justifyContent: "center",
        }}
      >
        <CustomButton
          title="Cancel"
          styles={{
            backgroundColor: colorWhite,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "10px",
          }}
          textStyles={{
            color: colorBlack,
          }}
          onClick={onClickBack}
        />{" "}
        <CustomButton
          title="Next"
          styles={{
            backgroundColor: primaryColor,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "10px 25px",
          }}
          textStyles={{
            color: colorWhite,
          }}
          onClick={() => {
            if (
              firstName !== "" &&
              lastName !== "" &&
              mobileNumber.length === 10 &&
              validateEmail(email)
            ) {
              onClickNext({
                email,
                firstName,
                lastName,
                mobileNumber,
                internal,
              });
            } else {
              if (firstName === "") {
                enqueueSnackbar("Please enter first name", {
                  variant: "error",
                });
              } else if (lastName === "") {
                enqueueSnackbar("Please enter last name", {
                  variant: "error",
                });
              } else if (!validateEmail(email)) {
                enqueueSnackbar("Please enter a valid email", {
                  variant: "error",
                });
              } else if (mobileNumber.length < 10) {
                enqueueSnackbar("Please enter a valid mobile number", {
                  variant: "error",
                });
              }
            }
          }}
          disabled={false}
        />
      </div>
    </div>
  );
}

export default BasicDetailsUser;
